import { render, staticRenderFns } from "./itemA.vue?vue&type=template&id=e5ec02be&scoped=true&"
import script from "./itemA.vue?vue&type=script&lang=js&"
export * from "./itemA.vue?vue&type=script&lang=js&"
import style0 from "./itemA.vue?vue&type=style&index=0&id=e5ec02be&lang=scss&scoped=true&"
import style1 from "./itemA.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ec02be",
  null
  
)

export default component.exports